export enum ExamType {
    Simulated = 1,
    Previous = 2
}
